export class ProtocolHDModel{
  prHdCode ='';
  prHdName ='';
  prHdCycle =0;
  prHdDays =0;
  prHdNotes ='';
  compCode ='1';
  userID ='sa';
  modifiedDate ='2022-01-01';
}

